import { c as _c } from "react/compiler-runtime";
import { HeaderLayoutLeftButton } from "@components/page-layout/header/header-layout-left-button";
import { MainPageLayout } from "@components/page-layout/main-page-layout";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useShouldShowAddCredits } from "@hooks/use-should-show-add-credits";
import { Box } from "@mui-wrapper";
import { ForbiddenPage } from "@pages/forbidden-page";
import { CreditPackages } from "@pages/settings/subscription-settings/credits/credit-packages";
import { SettingsTabs } from "@router/route-params";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useState } from "react";
import { CloseIcon } from "@flat-ui";

/** Renders a page with list of credit packages available for purchase */
export function AddCreditsPage() {
  const $ = _c(10);
  const {
    navigateToSettingsPage
  } = useAppNavigation();
  const companyId = useCompanyId();
  const {
    shouldShowAddCredits
  } = useShouldShowAddCredits();
  const [selectedPackage, setSelectedPackage] = useState(undefined);
  if (!shouldShowAddCredits) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ForbiddenPage />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      minHeight: "100vh",
      width: "100%"
    };
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== companyId || $[3] !== navigateToSettingsPage) {
    t1 = <HeaderLayoutLeftButton tooltip={`Close ${CREDITS_DISPLAY_NAME} page`} icon={CloseIcon} text="Close" onClickHandler={() => navigateToSettingsPage({
      companyId,
      settingsTab: SettingsTabs.subscription
    })} />;
    $[2] = companyId;
    $[3] = navigateToSettingsPage;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== selectedPackage) {
    t2 = <CreditPackages selectedPackage={selectedPackage} setSelectedPackage={setSelectedPackage} />;
    $[5] = selectedPackage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <Box sx={t0}><MainPageLayout shouldHideOpenButton={true} shouldShowSidebar={false} topLeftHeaderButton={t1} shouldUseFullBodyLayout={true}>{t2}</MainPageLayout></Box>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}